import React, { useEffect } from 'react'
import styled from '@emotion/styled'
import ExcelList from '../components/ExcelList'
import EmailPanel from '../components/EmailPanel'
import { loadEmail, loadExcel } from '../utils/connect'
import { useStateContext } from '../contexts/ContextProvider'

const ExcelListContainer = styled.div`
    width: 15vw;
`

const EmailPanelContainer = styled.div`
    width: 80vw;
`

const Container = styled.div`
    display: flex;
    flex-direction: row;
`
//{id:1, toSend:true, name: 'John Doe', company: 'TechCorp Ltd.', email:'123@163.com', date: '18th Sept.', join: 'Day1', status: 'Sent'},
//{id:2, toSend:false, name: 'Jane Smith', company: 'Innovate Inc.', email:'123@163.com', date: '19th Sept.', join: 'Day2', status: 'Error'},
//{id:3, toSend:false, name: 'Robert Brown', company: 'WebSolutions Co.', email:'123@163.com', date: '18th Sept.', join: 'Day1', status: 'Not sent'},

//UEN_number: "string"
//are_you_a_SME: "string"
//are_you_a_local_company: "string"
//are_you_new_to_China_market: "string"
//attendee_id: 0
//business_matching_meeting: "string"
//business_sector: "string"
//company_name: "string"
//completion_time: "2023-08-21T09:18:58"
//contact_number: "string"
//desgination: "string"
//disclaimer: "string"
//email: "string"
//email2: "aozora00321@gmail.com"
//full_name: "string"
//last_modified_date: "2023-08-21T09:18:58"
//name: "string"
//start_time: "2023-08-21T09:18:58"
//status: "No"

const getStatus = (status) => {
    if(status === 'No') {
        return 'Not sent'
    }
    else if(status === 'failed') {
        return 'Error'
    }
    else {
        return 'Sent'
    }
}

function SendEmailPage() {
    const { setSendData, setExcelList } = useStateContext();

    useEffect(() => {
        async function fetchData() {
            const responseData = await loadEmail();
            const responseProcess = responseData.map(item => ({
                id: item.attendee_id,
                toSend: item.status === "No" ? false : true,
                name: item.full_name,
                company: item.company_name,
                email: item.email2,
                business_matching_meeting: item.business_matching_meeting,
                status: getStatus(item.status)
            }));
            setSendData(responseProcess);
            console.log(responseProcess)
            const responseExcel = await loadExcel();
            setExcelList(responseExcel.map(item => ({name:item.file_name, url:item.link, date: item.start_time})))
            console.log(responseExcel);
        }

        fetchData();
    }, []);

    return (
        <Container>
            <ExcelListContainer>
                <ExcelList />
            </ExcelListContainer>
            <EmailPanelContainer>
                <EmailPanel />
            </EmailPanelContainer>
        </Container>
    )
}

export default SendEmailPage
